import { platformDetection } from "OK/platformDetection";

const WEBKIT_MESSAGE_HANDLERS = window.webkit?.messageHandlers;
const APP_PLATFORM_MESSAGE_EVENT = 'mobMessage';
const APP_AJAX_NAVIGATE_EVENT = 'ajaxNavigate';

/**
 * Получает хэндлер для отправки сообщений в iOS приложение
 */
function getIosPostMessageHandler(handler: string){
    return WEBKIT_MESSAGE_HANDLERS?.[handler];
}

/**
 * Служит для уведомления iOS приложения об аякс-навигации на другую страницу
 */
export const ajaxNavigationMessageHandler = getIosPostMessageHandler(APP_AJAX_NAVIGATE_EVENT);

/**
 * Служит для уведомления iOS приложения об иных событиях
 */
export const otherEventsIosMessageHandler = getIosPostMessageHandler(APP_PLATFORM_MESSAGE_EVENT);

/**
 * Отправляет в iOS приложение данные о текущем заголовке и конфиге в атрибуте data-page-config
 * (см. DataPageConfigAttr.java)
 */
export function updateTitleDataOnIos() {
    if (platformDetection.iOS && window?.okiosapp?.ok_titleLoaded) {
        const title = document.getElementsByTagName('title')[0];
        const pageConfig = title?.getAttribute('data-page-config') || '{}';
        window.okiosapp.ok_titleLoaded(document.title, pageConfig);
    }
}
